import { writable } from 'svelte/store';
import { browser } from '$app/environment';

export type OperatingSystem = 'macos' | 'windows' | 'linux';

// Detect user's OS
function detectOS(): OperatingSystem {
	if (!browser) return 'macos'; // Default for SSR
	
	const platform = window.navigator.platform.toLowerCase();
	const userAgent = window.navigator.userAgent.toLowerCase();
	
	if (platform.includes('mac') || userAgent.includes('mac')) {
		return 'macos';
	} else if (platform.includes('win') || userAgent.includes('win')) {
		return 'windows';
	} else {
		return 'linux';
	}
}

// Get initial OS from localStorage or detect
function getInitialOS(): OperatingSystem {
	if (!browser) return 'macos';
	
	const stored = localStorage.getItem('heyweek-selected-os');
	if (stored && ['macos', 'windows', 'linux'].includes(stored)) {
		return stored as OperatingSystem;
	}
	
	return detectOS();
}

// Create the store
function createOSStore() {
	const { subscribe, set, update } = writable<OperatingSystem>(getInitialOS());
	
	return {
		subscribe,
		set: (os: OperatingSystem) => {
			set(os);
			// Persist to localStorage
			if (browser) {
				localStorage.setItem('heyweek-selected-os', os);
				// Dispatch event for all OS code blocks to update
				window.dispatchEvent(new CustomEvent('os-selection-changed', { detail: { os } }));
			}
		},
		update
	};
}

export const selectedOS = createOSStore();